
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import WalletCustomer from "../components/walletamount";
import Footer from "../components/footer";

function WalletCustomerPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <WalletCustomer /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default WalletCustomerPage;
